<div id="top"></div>
<app-publicnavbar></app-publicnavbar>
      
      <br>
     
      <div class="container">
       
  
     
        <div class="jumbotron p-3 p-md-5 text-white rounded bg-dark">
          <div class="col-md-12 px-0">
            <h1 class="display-4 font-italic">Aetna’s Interoperability API Developer Portal</h1>
            <p class="lead my-3">Aetna has proudly adopted the HL7 FHIR standard to enable the exchange of HealthCare data to registered EHR/EMRs, Payer-to-Payer Participants, and Third-Party Applications.
            </p>
          <!--
            <p class="lead mb-0"><a routerLink="/dashboard" class="text-white font-weight-bold">Register now...</a></p>
          -->

          </div>
          
        </div>
  
        <div class="row mb-2">
        
          <div class="col-md-6">
            <div class="card flex-md-row mb-4 box-shadow h-md-250">
              <div class="card-body d-flex flex-column align-items-start">
                 <h4 class="mb-0">
                  <a class="text-dark" style="color: #7d3f98!important;" routerLink="/gettingstarted">Getting Started</a>
                </h4>
               
               <div *ngIf="home_getting_started" class="card-text mb-auto" style="color: #7d3f98!important;">
               <div  [innerHTML]="home_getting_started.properties.elements.main.value"></div>
               </div>
               
            
                <a class="btn btn-primary btn-lg" routerLink="/gettingstarted" role="button" style="background:  #7d3f98!important;border:  #7d3f98!important;">Learn more &raquo;</a>
             
              </div>
              <div routerLink="/gettingstarted" style="cursor: pointer;background: #7d3f98!important;">
                <svg xmlns="http://www.w3.org/2000/svg" width="160" height="80" style="background: #7d3f98!important; color: white;margin-top: 35%;"class="card-img-right flex-auto d-none d-md-block" fill="currentColor" class="bi bi-cursor-fill" viewBox="0 0 16 16">
                  <path d="M14.082 2.182a.5.5 0 0 1 .103.557L8.528 15.467a.5.5 0 0 1-.917-.007L5.57 10.694.803 8.652a.5.5 0 0 1-.006-.916l12.728-5.657a.5.5 0 0 1 .556.103z"/>
                </svg>
              </div>
              
            </div>
          </div>
          <div class="col-md-6">
          
            <div class="card flex-md-row mb-4 box-shadow h-md-250">
              <div class="card-body d-flex flex-column align-items-start">
                 <h4 class="mb-0">
                  <a class="text-dark" style="color: #7d3f98!important;" routerLink="/fhirapiasegregation">FHIR APIs</a>
                </h4>
                
               <div *ngIf="home_fhir_apis" class="card-text mb-auto" style="color: #7d3f98!important;">
              
                <div  [innerHTML]="home_fhir_apis.properties.elements.main.value"></div>    
               </div>
               
               <br>  
                <a class="btn btn-primary btn-lg" routerLink="/fhirapiasegregation" role="button" style="background:  #7d3f98!important;border:  #7d3f98!important;">Learn more &raquo;</a>
             
              </div>
              <div  routerLink="/fhirapiasegregation" style="cursor: pointer;background: #7d3f98!important;">
              <svg xmlns="http://www.w3.org/2000/svg" width="180" height="80" style="background: #7d3f98!important; color: white; margin-top: 35%;"class="card-img-right flex-auto d-none d-md-block" fill="currentColor" class="bi bi-code-slash" viewBox="0 0 16 16">
                <path d="M10.478 1.647a.5.5 0 1 0-.956-.294l-4 13a.5.5 0 0 0 .956.294l4-13zM4.854 4.146a.5.5 0 0 1 0 .708L1.707 8l3.147 3.146a.5.5 0 0 1-.708.708l-3.5-3.5a.5.5 0 0 1 0-.708l3.5-3.5a.5.5 0 0 1 .708 0zm6.292 0a.5.5 0 0 0 0 .708L14.293 8l-3.147 3.146a.5.5 0 0 0 .708.708l3.5-3.5a.5.5 0 0 0 0-.708l-3.5-3.5a.5.5 0 0 0-.708 0z"/>
              </svg>
              </div>
            </div>
          
          </div>

        </div>
      
     
    
        

        <div class="row mb-2">
        
          
            <div class="col-md-6">
              <div class="card flex-md-row mb-4 box-shadow h-md-250">
                <div class="card-body d-flex flex-column align-items-start">
                   <h4 class="mb-0">
                    <a class="text-dark" style="color: #7d3f98!important;" routerLink="/support">Help</a>
                  </h4>
                 
                 <div *ngIf="home_help"  class="card-text mb-auto" style="color: #7d3f98!important;">
                  
                  
                  <div  [innerHTML]="home_help.properties.elements.main.value"></div>
                  <br> 
                </div>
                 
              
                  <a class="btn btn-primary btn-lg" routerLink="/support" role="button" style="background:  #7d3f98!important;border:  #7d3f98!important;">Learn more &raquo;</a>
               
                </div>
                <div routerLink="/support" style="cursor: pointer;background: #7d3f98!important;">


                  <svg xmlns="http://www.w3.org/2000/svg" style="color: white;margin-top: 30px;" width="180" height="80" fill="currentColor" class="bi bi-envelope" viewBox="0 0 16 16">
                    <path d="M0 4a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V4Zm2-1a1 1 0 0 0-1 1v.217l7 4.2 7-4.2V4a1 1 0 0 0-1-1H2Zm13 2.383-4.708 2.825L15 11.105V5.383Zm-.034 6.876-5.64-3.471L8 9.583l-1.326-.795-5.64 3.47A1 1 0 0 0 2 13h12a1 1 0 0 0 .966-.741ZM1 11.105l4.708-2.897L1 5.383v5.722Z"/>
                  </svg>
                 
                </div>
                
              </div>
            </div>
        
          <div class="col-md-6">
            <div class="card flex-md-row mb-4 box-shadow h-md-250">
              <div class="card-body d-flex flex-column align-items-start">
                 <h4 class="mb-0">
                  <a class="text-dark" style="color: #7d3f98!important;" routerLink="/announcement">Announcements</a>
                </h4>
               
               <div *ngIf="home_announcements" class="card-text mb-auto" style="color: #7d3f98!important;">
               
                
                <div  [innerHTML]="home_announcements.properties.elements.main.value"></div>
              
              </div>
               
            
                <a class="btn btn-primary btn-lg" routerLink="/announcement" role="button" style="background:  #7d3f98!important;border:  #7d3f98!important;">Learn more &raquo;</a>
             
              </div>
              <div routerLink="/announcement" style="cursor: pointer;background: #7d3f98!important;">
                <svg xmlns="http://www.w3.org/2000/svg" width="180" height="80" style="color: white;margin-top: 30%;" fill="currentColor" class="bi bi-chat-square-text" viewBox="0 0 16 16">
                  <path d="M14 1a1 1 0 0 1 1 1v8a1 1 0 0 1-1 1h-2.5a2 2 0 0 0-1.6.8L8 14.333 6.1 11.8a2 2 0 0 0-1.6-.8H2a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1h12zM2 0a2 2 0 0 0-2 2v8a2 2 0 0 0 2 2h2.5a1 1 0 0 1 .8.4l1.9 2.533a1 1 0 0 0 1.6 0l1.9-2.533a1 1 0 0 1 .8-.4H14a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2H2z"/>
                  <path d="M3 3.5a.5.5 0 0 1 .5-.5h9a.5.5 0 0 1 0 1h-9a.5.5 0 0 1-.5-.5zM3 6a.5.5 0 0 1 .5-.5h9a.5.5 0 0 1 0 1h-9A.5.5 0 0 1 3 6zm0 2.5a.5.5 0 0 1 .5-.5h5a.5.5 0 0 1 0 1h-5a.5.5 0 0 1-.5-.5z"/>
                </svg>
              </div>
              
            </div>
          </div>
         

        </div>
      <!--
        <div class="row featurette">
          <div class="col-md-7">
            <h2 class="featurette-heading" style="color: #7d3f98!important;">Announcements</h2>
            <p class="card-text mb-auto p-custom">Third Party Developer/Payer should be able to use web form created in Developer Portal to
              submit Third Party Developer/Payer questionnaire to begin the process of subscribing to Aetna’s
              Interoperability APIs.</p>
              <br>
              <p><a class="btn btn-primary btn-lg" routerLink="/announcement" role="button" style="background:  #7d3f98!important;border:  #7d3f98!important;">Learn more &raquo;</a></p>
          </div>
          <div class="col-md-2">

          </div>
          <div class="col-md-3" style="background: #7d3f98!important;">
                     
            
            <svg xmlns="http://www.w3.org/2000/svg" width="180" height="80" style="color: white;margin-top: 40%;
            margin-left: 15%;" fill="currentColor" class="bi bi-chat-square-text" viewBox="0 0 16 16">
              <path d="M14 1a1 1 0 0 1 1 1v8a1 1 0 0 1-1 1h-2.5a2 2 0 0 0-1.6.8L8 14.333 6.1 11.8a2 2 0 0 0-1.6-.8H2a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1h12zM2 0a2 2 0 0 0-2 2v8a2 2 0 0 0 2 2h2.5a1 1 0 0 1 .8.4l1.9 2.533a1 1 0 0 0 1.6 0l1.9-2.533a1 1 0 0 1 .8-.4H14a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2H2z"/>
              <path d="M3 3.5a.5.5 0 0 1 .5-.5h9a.5.5 0 0 1 0 1h-9a.5.5 0 0 1-.5-.5zM3 6a.5.5 0 0 1 .5-.5h9a.5.5 0 0 1 0 1h-9A.5.5 0 0 1 3 6zm0 2.5a.5.5 0 0 1 .5-.5h5a.5.5 0 0 1 0 1h-5a.5.5 0 0 1-.5-.5z"/>
            </svg>
          
           
          </div>
        </div>  -->
<!--
        <hr class="featurette-divider" style="background: #7d3f98!important;">

        <div class="row featurette">
          <div class="col-md-7 order-md-2">
            <h2 class="featurette-heading" style="color: #7d3f98!important;">Helpful Hints. </h2>
            
             
              <ul class="card-text mb-auto p-custom">
                <li > Within any application you create, you can view your Client ID, Subscriptions, Update App and View API Products.</li>
                <li> Updating the app allows you to change your Callback URL, Delete the App, Reset the Client Secret (in case you forgot to write it down) and verify the Client Secret.</li>
                <li> Verifying the Client Secret can be helpful if you have created multiple apps and cannot remember which client secret applies to which app.</li>
                <li> For each API that is subscribed, be sure to subscribe to <b> ALL </b>fhir APIs (fhir, fhir-a, fhir-d, etc.) to ensure successful API connection.</li>
                <li> If you are already approved for sandbox and request access to production APIs, a new questionnaire is not needed. Please allow some time for the access to be approved. </li>
                <li> If you are already approved for production and request access to sandbox, your access will automatically be approved. </li>
                <li> Please refrain from deleting all applications and subscriptions in any environment. Doing so will cause any new applications and subscriptions to receive a pending status. Should this happen, <a class="aetnaMainDiv" href="mailto:AetnaInteroperabilityProductionAccess@aetna.com "> <u> email </u> </a> for assistance. </li>
              </ul>
           
          </div>
          <div class="col-md-5 order-md-1">
          
        
            <svg xmlns="http://www.w3.org/2000/svg" style="background: #7d3f98!important; color: white;" class="featurette-image img-fluid mx-auto" fill="currentColor" class="bi bi-info-square-fill" viewBox="0 0 16 16">
              <path d="M0 2a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V2zm8.93 4.588-2.29.287-.082.38.45.083c.294.07.352.176.288.469l-.738 3.468c-.194.897.105 1.319.808 1.319.545 0 1.178-.252 1.465-.598l.088-.416c-.2.176-.492.246-.686.246-.275 0-.375-.193-.304-.533L8.93 6.588zM8 5.5a1 1 0 1 0 0-2 1 1 0 0 0 0 2z"/>
            </svg>
        
          </div>
        </div>
      -->

      </div>
  
    
      <p-dialog [modal]="true" [closable]="false" header="Please Wait" [(visible)]="display" [style]="{width: '50vw'}" >
                
        <div class="container-fluid" style="width:99%" >
          <div class="row" >
            <div class="col-md-5">
              <div *ngIf="errorUserProfile"><h2 style="color:red">Invalid email id. {{message}}</h2></div>
              <div *ngIf="displayErrorMSG"><h2 style="color:red">Error: {{displayErrorMSG}}</h2></div>
            </div>
            <div class="col-md-2" *ngIf="spinner">
            
                <p-progressSpinner  [style]="{width: '50px', height: '50px'}" strokeWidth="8" fill="#EEEEEE" animationDuration=".5s"></p-progressSpinner>
            </div>
            <div class="col-md-5"></div>
          </div> 
        </div>
  </p-dialog>
